<template>
  <transition name="plus-icon">
    <div class="modelBox" v-if="isShow">
      <div class="model">
        <div class="head">
          <p>{{ name }}</p>
        </div>
        <div class="content">
          <h4>{{ title }}</h4>
          <p>{{ desc1 }}</p>
          <p>{{ desc2 }}</p>
          <p>{{ desc3 }}</p>
        </div>
        <div class="btn hvr-shutter-out-horizontal" @click="changeModel">
          <p>{{ close }}</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    isShow: Boolean,
    name: String,
    desc1: String,
    desc2: String,
    desc3: String,
    title: String
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      language: "getType"
    }),
    close() {
      return this.language == "中文" ? "关闭" : "Back";
    }
  },
  methods: {
    changeModel() {
      this.$emit("changeModel", false);
    }
  }
};
</script>

<style lang="less" scoped>
.plus-icon-enter-active {
  transition: opacity 0.5s;
}
.plus-icon-enter {
  opacity: 0;
}
.plus-icon-leave-active {
  transition: opacity 0.5s;
}
.plus-icon-leave-to {
  opacity: 0;
}
.plus-icon-enter-to {
  opacity: 1;
}
.hvr-shutter-out-horizontal:before {
  background: rgba(255, 125, 51, 1);
}

.modelBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.6);
  .model {
    position: fixed;
    width: 355px;
    height: 380px;
    background: rgba(255, 255, 255, 1);
    background-image: url("../assets/brid.png");
    background-position: 0% 100%;
    background-size: 200px 130px;
    background-repeat: no-repeat;
    border-radius: 15px;
    white-space: pre-line;
    top: 50%;
    left: 50%;
    margin-left: -172.5px;
    margin-top: -190px;
    .head {
      width: 180px;
      height: 60px;
      background: url("../assets/button.png");
      background-size: 100% 100%;
      position: absolute;
      top: -32px;
      left: 50%;
      margin-left: -90px;
      p {
        font-size: 26px;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 58px;
      }
    }
    .content {
      width: 300px;
      margin: 20px auto 0;
      height: 265px;
      overflow: auto;
      h4 {
        margin-top: 16px;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        text-align: center;
        margin-bottom: 50px;
      }
      p {
        font-size: 13px;
        color: rgba(51, 51, 51, 1);
        margin-top: 20px;
      }
    }
    .btn {
      width: 220px;
      overflow: hidden;
      height: 48px;
      background: rgba(255, 125, 51, 0.7);
      border-radius: 27px;
      cursor: pointer;
      transform: scale(0.7);
      position: absolute;
      bottom: 20px;
      left: 50%;
      margin-left: -110px;
      p {
        font-size: 26px;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 48px;
      }
    }
  }
}
//滚动条样式
::-webkit-scrollbar {
  width: 10px;
}
/* 垂直滚动条的滑动块 */
::-webkit-scrollbar-thumb:vertical {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 6px rgba(255, 125, 51, 0.5);
  background-color: rgba(255, 125, 51, 0.5);
}

::-webkit-scrollbar-track {
  box-shadow: 0px 0px 3px #dfdfdf inset;
  border-radius: 10px;
  background: #eee;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(255, 125, 51, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/components/model.vue